export default function cmToIn(cm: number) {
	return Math.round(cm / 2.54);
}
